import styled from 'styled-components';

export function Button({ children, onClick, variant = 'apply' }) {
  return (
    <StyledButton onClick={onClick} $variant={variant}>
      {children}
    </StyledButton>
  );
}

const StyledButton = styled.button`
  width: 100%;
  padding: 0 16px;
  height: 40px;
  background: transparent;
  border: 1px solid
    ${({ $variant }) => ($variant === 'apply' ? '#83bf46' : '#ff5152')};
  border-radius: 8px;
  color: ${({ $variant }) => ($variant === 'apply' ? '#83bf46' : '#ff5152')};
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: ${({ $variant }) =>
      $variant === 'apply' ? '#83bf46' : '#ff5152'};
    color: #fff;
  }
`;
